import router from './router/router';
import store from './store';
import NProgress from 'nprogress'; // progress bar
import 'nprogress/nprogress.css'; // progress bar style
import {asyncRouterMap} from '@/router/router';
import LoginApi from "@/api/LoginApi";
import RecordApi from "./api/record"
import {menu} from '@/mock/menu'
import {convertToMenu, convertToRoute} from "@/util/util";
import {Message} from "element-ui"
import auth from "./util/auth"
import {clearStore, getStore, getToken, setStore} from './util/store';
import aaasSsoHandler from "@/login/handler/SsoHandler"


NProgress.configure({
    showSpinner: false
}) // NProgress Configuration
function hasPermission(roles, permissionRoles) {
    if (!permissionRoles) return true
    return roles.some(role => permissionRoles.indexOf(role) >= 0)
}

const lockPage = store.getters.website.lockPage;
router.addRoutes(asyncRouterMap); // 动态添加可访问路由表
router.beforeEach(async (to, from, next) => {
    NProgress.start();// start progress bar
    aaasSsoHandler(to, from, next)
})
// 处理sso相关逻辑
function handleSso(to, next) {
    let token = getToken() || auth.getToken()
    let errorCode = to.query.errCode;
    let key = to.query.key;
    let accountId = to.query.accountId;
    let itemKey = to.query.itemKey;
    let redirectUrl = to.fullPath;
    let cbUrl = to.query.redirectUrl;
    return new Promise(async (resolve, reject) => {
        if (itemKey) {
            let cachedKey = getStore({name: "cache_item_key",type:"session"})
            if(cachedKey===itemKey){
                resolve(-1)
                return
            }
            setStore({name: "cache_item_key",content: itemKey,type: "session"})
            // 从sca跳转过来，交换token
            LoginApi.exchangeToken({ itemKey: itemKey }).then(async res => {
                await store.dispatch("setToken", res.data)
                resolve(1)
            }).catch(e => {
                clearStore({ type: "session" })
                clearStore({})
                reject(e)
            })
        }
        else if (key && accountId) {
            // let modifiedUrl = ''
            // if(redirectUrl.includes('%23')) {
            //     modifiedUrl = redirectUrl
            // } else {
            //     if (process.env.SSO_HOST === "'https://sca.cncecyc.com") {
            //         modifiedUrl = '/#' + redirectUrl
            //     } else {
            //         modifiedUrl = '/foreign/#' + redirectUrl
            //     }
            // }
            // window.location.href = process.env.SSO_HOST+"/ibs/loginOaNew?appId="+process.env.SSO_APP_ID + '&redirectUrl=' + encodeURIComponent(location.href);
            // oa跳转
            LoginApi.accessSca({ key, accountId, appId: process.env.SSO_APP_ID }).then(async res => {
                await store.dispatch("setToken", res.data)
                resolve(1)
            }).catch((e) => {
                reject(e)
            })
        }
        else if (errorCode) {
            clearStore({ type: "session" })
            clearStore({})
            auth.removeToken()
            reject()
        }
        else if (to.path == "/login" || to.path == "/blank") {
            // 登录页直接放过
            next()
        }
        else if (token) {
            // 不设置没有getter
            await store.dispatch("setToken", token)
            resolve(0)
        }
        else {
            let url = process.env.SSO_HOST+"/ibs/loginOaNew?appId="+process.env.SSO_APP_ID;
            url += `&redirectUrl=${encodeURIComponent(location.href)}`
            window.location.href = url
        }
    })
}
function isWhiteList(to) {
    let flag = false;
    const whiteList = store.getters.website.whiteList
    for (let i = 0; i < whiteList.length; i++) {
        if (new RegExp("^" + whiteList[i].toString() + ".*", "g").test(to.path)) {
            flag = true;
            break;
        }
    }
    return flag
}
// 处理路由和菜单
function handleMenu(code) {
    return new Promise(async (resolve, reject) => {
        if (!getToken()) {
            reject()
        }
        if (code) {
            let loginApi = new LoginApi();
            //获取应用路由
            let menuData = await loginApi.getMenu({ appId: store.getters.appId })
            //存储该用户在该应用下动态路由
            let routes = convertToRoute(menuData.data)
            //存储该用户在该应用下的菜单
            let menus = convertToMenu(menuData.data)
            if (!menus.length) {
                reject("您没有该应用权限")
                return
            }
            setStore({ name: "foreign_menu", content: menuData.data });
            await store.dispatch("setRoute", routes)
            await store.dispatch("setMenu", menus.concat(menu))
            resolve()
        }
        else if (!store.getters.menu.length) {
            let cached = getStore({ name: "foreign_menu" })
            if (cached) {
                let routes = convertToRoute(cached)
                //存储该用户在该应用下的菜单
                let menus = convertToMenu(cached)
                if (!menus.length) {
                    reject("您没有该应用权限")
                    return
                }
                await store.dispatch("setRoute", routes)
                await store.dispatch("setMenu", menus.concat(menu))
                resolve()
            }
            else {
                let loginApi = new LoginApi();
                //获取应用路由
                let menuData = await loginApi.getMenu({ appId: store.getters.appId })
                //存储该用户在该应用下动态路由
                let routes = convertToRoute(menuData.data)
                //存储该用户在该应用下的菜单
                let menus = convertToMenu(menuData.data)
                if (!menus.length) {
                    reject("您没有该应用权限")
                    return
                }
                setStore({ name: "foreign_menu", content: menuData.data });
                await store.dispatch("setRoute", routes)
                await store.dispatch("setMenu", menus.concat(menu))
                resolve()
            }
        }
        else {
            resolve()
        }
    })
}
// 处理用户详情
function handleUserInfo(to,next, code) {
    return new Promise(async (resolve, reject) => {
        if (!getToken()) {
            reject()
        }
        if (code) {
            let loginApi = new LoginApi();
            let recordApi = new RecordApi()
            let userData = await loginApi.getUserInfo({})
            let record = await recordApi.detail({ companyId: userData.data.userInfo.companyId })
            //存储该用户在该应用下的菜单
            await store.dispatch("setUserInfo", userData.data)
            setStore({ name: "foreign_userinfo", content: userData })
            setStore({ name: "foreign_record", content: record })
            if (record.data) {
                // 除去集团公司，其他满足条件都去公司备案页面
                if (record.data.entRecord.status !== "60" && to.path!=="/company_on_record" && record.data.entRecord.companyId !== "1000000000000000000") {
                    next({ path: "/company_on_record" })
                    resolve(304)
                    return
                }else if(record.data.entRecord.status === "60" && !record.data.zb && record.data.entRecord.companyId !== "1000000000000000000") {
                    next({ path: "/login" })
                    reject("您没有备案")
                    return
                }
            }
            else {
                next({ path: "/company_on_record" })
                resolve(304)
                return
            }
            await store.dispatch("setSigner", record.data)
            resolve()
        }
        else {
            let userData = getStore({ name: "foreign_userinfo" }),
                record = getStore({ name: "foreign_record" })
            // 如果已经有菜单
            if (userData && record) {
                await store.dispatch("setUserInfo", userData.data)
                if (record.data) {
                    // 除去集团公司，其他满足条件都去公司备案页面
                    if (record.data.entRecord.status !== "60" && to.path!=="/company_on_record" && record.data.entRecord.companyId !== "1000000000000000000") {
                        next({ path: "/company_on_record" })
                        resolve(304)
                        return
                    }else if(record.data.entRecord.status === "60" && !record.data.zb && record.data.entRecord.companyId !== "1000000000000000000") {
                      next({ path: "/login" })
                      reject("您没有备案")
                      return
                    }
                }
                else {
                    next({ path: "/company_on_record" })
                    resolve(304)
                    return
                }
                // 设置签发人
                await store.dispatch("setSigner", record.data)
                resolve()
            }
            else {
                let loginApi = new LoginApi();
                let recordApi = new RecordApi()
                userData = await loginApi.getUserInfo({})
                record = await recordApi.detail({ companyId: userData.data.userInfo.companyId })
                //存储该用户在该应用下的菜单
                await store.dispatch("setUserInfo", userData.data)
                setStore({ name: "foreign_userinfo", content: userData })
                setStore({ name: "foreign_record", content: record })
                // 设置签发人
                if (record.data) {
                    // 除去集团公司，其他满足条件都去公司备案页面
                    if (record.data.entRecord.status !== "60" && to.path!=="/company_on_record" && record.data.entRecord.companyId !== "1000000000000000000") {
                        next({ path: "/company_on_record" })
                        reject("请先备案")
                    }else if(record.data.entRecord.status === "60" && !record.data.zb && record.data.entRecord.companyId !== "1000000000000000000") {
                      next({ path: "/login" })
                      reject("您没有备案")
                      return
                    }
                }
                else {
                    next({ path: "/company_on_record" })
                    reject("请先备案")
                }
                await store.dispatch("setSigner", record.data)
                resolve()
            }
        }
    })
}
// 获取可访问资源
async function handlePermission(code) {
    let appId = process.env.APP_ID; // appId
    if (!getToken()) {
        return
    }
    if (code) {
        //存储该用户可访问资源
        let loginApi = new LoginApi();
        let permissionData = await loginApi.getPermission({ appId })
        setStore({ name: "foreign_permission", content: permissionData.data })
        return store.dispatch("setPermission", permissionData.data)
    }
    else {
        let permissionData = getStore({ name: "foreign_permission" })
        if (permissionData) {
            return store.dispatch("setPermission", permissionData)
        }
        else {
            let loginApi = new LoginApi();
            let permissionData = await loginApi.getPermission({ appId })
            setStore({ name: "foreign_permission", content: permissionData.data })
            return store.dispatch("setPermission", permissionData.data)
        }
    }

}
// 处理上方标签
function handleTag(to) {
    if (!store.getters.token) {
        store.commit('DEL_ALL_TAG');
    }
    else if (!to.query.appId) {
        const value = to.query.src ? to.query.src : to.path;
        const label = to.query.name ? to.query.name : to.name;
        store.commit('ADD_TAG', {
            label: label,
            value: value,
            query: to.query
        });
    }
}

//寻找子菜单的父类
function findMenuParent(tag) {
    let tagCurrent = [];
    const menu = store.getters.menu;
    tagCurrent.push(tag);
    return tagCurrent;
}

router.afterEach((to, from) => {
    NProgress.done();
    setTimeout(() => {
        const tag = store.getters.tag;
        // setTitle(tag.label);
        store.commit('SET_TAG_CURRENT', findMenuParent(tag));
        /*//百度统计代码
        var _hmt = _hmt || [];
        (function () {
            //每次执行前，先移除上次插入的代码
            document.getElementById('baidu_tj') && document.getElementById('baidu_tj').remove();
            var hm = document.createElement("script");
            hm.src = "https://hm.baidu.com/hm.js?23c7f40fa073fadc2a7f8bfe079fd17f";
            hm.id = "baidu_tj"
            var s = document.getElementsByTagName("script")[0];
            s.parentNode.insertBefore(hm, s);
        })();*/
        window.dataLayer = window.dataLayer || [];
        function gtag() {
            dataLayer.push(arguments);
        }
        gtag('js', new Date());
        gtag('config', 'UA-105756702-2');
    }, 0);
})
